export default function BetterCheckbox({
  label,
  field,
  disabled = false,
  checked = undefined,
}) {
  return (
    <label
      htmlFor={field.name}
      className={`form-check-label border ${
        disabled
          ? "border-light-subtle text-secondary"
          : "border-secondary-subtle"
      } rounded-1 pt-1 pb-1 pr-1 ps-2 m-0 user-select-none c-pointer`}
    >
      <input
        ref={field.ref}
        id={field.name}
        className="form-check-input mx-1"
        type="checkbox"
        checked={checked !== undefined ? checked : Boolean(field.value)}
        onChange={e => field.onChange(e.target.checked)}
        disabled={disabled}
      />
      {label}
    </label>
  );
}
